module.exports = __webpack_public_path__ + "static/media/c.afdcf1ab.jpg";